export default function Introduction() {
    return (
        <>
            <div className="personal-statement">
                Early-career Software Engineer and CS Cum Laude graduate with experience in production systems, test automation, and data-driven operational improvements. Contributed to a logging migration initiative projected to reduce costs by ~40% and prototyped internal tools to help a small business better understand POS data and store operations. Strong foundation in Python, SQL, and JavaScript with a focus on reliability, clarity, and continuous learning.
            </div>
        </>
    )
}